import { createContext, useState } from 'react';

const ActiveMenuContext = createContext();

export const ActiveMenuProvider = ({ children }) => {
  const [activeMenu, setActiveMenu] = useState('');

  return (
    <ActiveMenuContext.Provider value={{ activeMenu, setActiveMenu }}>
      {children}
    </ActiveMenuContext.Provider>
  );
};

export default ActiveMenuContext;
